(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sudzero-athletes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sudzero-athletes')) {
    customElements.define('sudzero-athletes', class extends HTMLElement {
      connectedCallback() {
        this.initialized = false;
        this.ready = new MutationObserver(() => this.initialize());
        this.ready.observe(this, { childList: true, subtree: true });
        this.initialize();
      }
      initialize() {
        if (this.initialized) return;
        this.track = this.querySelector('[data-athletes-track]');
        this.controls = this.querySelector('[data-athletes-controls]');
        this.previous = this.querySelector('[data-athletes-prev]');
        this.next = this.querySelector('[data-athletes-next]');
        if (!this.track) return;
        this.initialized = true;
        this.ready.disconnect();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * direction);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : direction * this.track.scrollWidth, behavior: this.motion() });
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = Array.from(this.track.children).find(item => item.dataset.athleteId === event.detail.blockId);
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(() => this.scheduleUpdate());
        this.resize.observe(this.track);
        this.scheduleUpdate();
      }
      disconnectedCallback() {
        this.ready?.disconnect();
        this.initialized = false;
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      motion() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }
      move(step) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: step * direction * (card.getBoundingClientRect().width + gap), behavior: this.motion() });
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          const overflowing = maximum > 3;
          this.controls.hidden = !overflowing;
          this.track.tabIndex = overflowing ? 0 : -1;
          this.previous.disabled = !overflowing || position <= 3;
          this.next.disabled = !overflowing || position >= maximum - 3;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sz-hero-section-produkt"] && !Shopify.designMode) return;
  try {
    

  const initSudzeroFeatured = (section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const radios = section.querySelectorAll('[data-sz-variant-radio]');
    const price = section.querySelector('[data-sz-price]');
    const compareWrap = section.querySelector('[data-sz-compare-wrap]');
    const comparePrice = section.querySelector('[data-sz-compare-price]');
    const selectedVariant = section.querySelector('[data-sz-selected-variant]');
    const submit = section.querySelector('[data-sz-submit]');
    const submitText = section.querySelector('[data-sz-submit-text]');

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        const available = radio.dataset.available === 'true';
        const compare = radio.dataset.compare;

        if (price) price.textContent = radio.dataset.price || '';
        if (selectedVariant) selectedVariant.textContent = radio.dataset.title || '';

        if (compareWrap && comparePrice) {
          if (compare && compare.trim() !== '') {
            comparePrice.textContent = compare;
            compareWrap.classList.remove('is-hidden');
          } else {
            comparePrice.textContent = '';
            compareWrap.classList.add('is-hidden');
          }
        }

        if (submit && submitText) {
          submit.disabled = !available;
          submitText.textContent = available ? section.dataset.addLabel : 'Ausverkauft';
        }
      });
    });

    const qtyInput = section.querySelector('[data-sz-qty-input]');
    const qtyMinus = section.querySelector('[data-sz-qty-minus]');
    const qtyPlus = section.querySelector('[data-sz-qty-plus]');

    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', () => {
        const current = (parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = Math.max(1, current - 1);
      });

      qtyPlus.addEventListener('click', () => {
        const current = (parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = Math.max(1, current + 1);
      });
    }
  };
  document.querySelectorAll('[data-sz-hero-product]').forEach(initSudzeroFeatured);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-sz-hero-product]').forEach(initSudzeroFeatured); });


  } catch(e) { console.error(e); }
})();
})();
